export default "__VITE_ASSET__BToM6UPv__"